import React, { useState, type ComponentType } from 'react';

import { WorkJourneyProvider } from '../contexts/WorkJourneyProvider';

interface JourneyTypeValue {
  workJourneyType: string | null;
  setWorkJourneyType: React.Dispatch<React.SetStateAction<string | null>>;
}

interface WorkJourneyRouteWrapperProps {
  component: ComponentType<{ value?: JourneyTypeValue; [key: string]: unknown }>;
  routeProps?: Record<string, unknown>;
}

/**
 * Wrapper that wraps the WorkJourney route components with the Context Provider
 */
const WorkJourneyRouteWrapper = ({
  component: Component,
  routeProps = {},
  ...rest
}: WorkJourneyRouteWrapperProps) => {
  const [workJourneyType, setWorkJourneyType] = useState<string | null>(null);

  return (
    <WorkJourneyProvider>
      <Component {...routeProps} {...rest} value={{ workJourneyType, setWorkJourneyType }} />
    </WorkJourneyProvider>
  );
};

export default WorkJourneyRouteWrapper;
